import { applyImpersonationFromUrl } from '@shared/auth/impersonation';

applyImpersonationFromUrl();
